export default __webpack_public_path__ + "static/assets/4059a2c6faffab7605b274888fe38de3.png";